<script>
import _ from 'lodash'
import OrgService from '@/request/user/org'
import UserService from '@/request/user/user'
import SigningService from '@/request/aims/signingOperator'
export default {
  name: 'AimsSigningEdit',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    hospital: {
      type: Number
    }
  },
  data () {
    return {
      hospitals: [],
      visibleEditOperator: false,
      editOperator: {
        sn: null,
        hid: null,
        uid: null,
        mobile: null,
        name: null
      }
    }
  },
  created () {
    if (!this.hospital) {
      this.listHospital()
    } else {
      this.editOperator.hid = this.hospital
    }
  },
  watch: {},
  methods: {
    listHospital () {
      let self = this
      OrgService.listOrg({
        parents: 1,
        typeSns: 'lx0001001'
      }).then(res => {
        self.hospitals = _.cloneDeep(res.result || [])
        if (self.hospitals.length === 1) {
          self.editOperator.hid = self.hospitals[0].id
        }
      }).catch(() => {
        self.hospitals = []
      })
    },
    querySearchUserAsync (match, callback) {
      let result = []
      if (!match || match.length < 8) {
        callback(result)
        return
      }
      UserService.list({
        match: match
      }).then(res => {
        let result = res.result || []
        if (!_.isEmpty(result)) {
          this.editOperator.uid = null
          this.editOperator.name = null
        }
        callback(result)
      }, () => {
        callback(result)
      })
    },
    handleSelectUser (item) {
      if (item) {
        this.editOperator.uid = item.id
        this.editOperator.mobile = item.mobile
        this.editOperator.name = item.name
      }
    },
    save () {
      let self = this
      self.$refs['editOperatorForm'].validate(valid => {
        if (!valid) {
          self.$message.error('表单验证失败!')
          return
        }
        SigningService.save(self.editOperator).then(res => {
          this.$emit('save-done', res.result)
        }).catch(error => {
          self.$message.error(error || '添加主刀失败!')
        })
      }, () => {
        self.$message.error('表单验证失败!')
      })
    }
  }
}
</script>

<template>
  <el-form ref="editOperatorForm" :model="editOperator">
    <el-form-item label="医院" prop="hid" v-if="!hospital">
      <el-select v-model="editOperator.hid" :disabled="hospitals.length <= 1" placeholder="请选择医院" style="width: 100%;">
        <el-option
          v-for="item in hospitals"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="手机号" prop="mobile" :rules="{required: true, message: '手机号不能为空', trigger: 'blur'}">
      <el-autocomplete
        v-model="editOperator.mobile"
        :fetch-suggestions="querySearchUserAsync"
        placeholder="请输入手机号"
        value-key="name"
        @select="handleSelectUser"
        style="width: 100%;">
      </el-autocomplete>
    </el-form-item>
    <el-form-item label="姓名" prop="name" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
      <el-input v-model="editOperator.name" placeholder="请输入姓名"></el-input>
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
